// W2-3 — THE TURN NOTICE. ONE component, rendered by the Ask Lala PAGE and the DRAWER.
//
// Her ruling asked for one notice in two places, and this site has already paid for the alternative:
// the drawer and the page ran the same mind through two copies of the chrome until the copies
// disagreed. So the notice is a component, both surfaces render it directly above the text box, and
// there is nothing here to keep in sync.
//
// It takes props, holds no state and calls no hook, which is the entry requirement for
// `scripts/w2-turn-notice.mjs` to CALL it and read the tree back. It also composes NOTHING: the
// sentence arrives from `server/lala-cap.js`, so the wording of the cap has exactly one home.
//
// FUNNEL-4 — AND IT NOW CARRIES THE FREE-TURN COUNTER AND THE WARM WALL, in the same slot, for the
// same reason it carries the cap notice: two surfaces, one law, nothing to keep in step. WHICH of
// the two is drawn is `freeTurnView`'s answer and never a comparison typed here — the allotment
// outranks the daily notice, because a free account has no daily allowance to come back for.
import type { TurnNotice } from "../lib/lala-turns";
import { freeTurnView } from "../lalaFreeTurns.js";
import { t } from "../strings.js";
// ITEM G3 — in the store app the free-turn wall invites nobody to buy (R3, P2).
import { APP_MODE } from "../lib/appMode";
import { NOT_INCLUDED_LINE } from "../storeApp/NotIncluded";

export function LalaTurnNotice({
  notice,
  freeTurns = null,
  language = "en",
  onUpgrade,
}: {
  notice: TurnNotice;
  freeTurns?: unknown;
  language?: string;
  onUpgrade?: () => void;
}) {
  const view = freeTurnView(freeTurns);
  if (view && view.kind === "counter") {
    // Her clause 3: "a soft visible counter, never a scoreboard". One line, her words, in her
    // language, drawn in the same place the cap notice would have been.
    return (
      <p className="lala-turns lala-turns--free" role="status">
        {t(language, view.key, { n: view.n })}
      </p>
    );
  }
  if (view && view.kind === "wall") {
    // Her clause 3: the wall lands "at the exact moment desire is highest" and it is a DOOR rather
    // than a stop. The sentence is Lala's own and arrives in the thread as her last message; this is
    // the way through, so it is a real control and never a line of text.
    return (
      <div className="lala-turns lala-turns--wall" role="status">
        <p className="lala-turns__title">{t(language, view.title)}</p>
        <p className="lala-turns__body">{APP_MODE ? NOT_INCLUDED_LINE : t(language, view.body)}</p>
        {/* ITEM 2 — HER GOLD BUTTON. It carried `.button` alone, which declares no colour and no
            background at all, so it drew in whatever ink surrounded it on the plum panel. The gold
            plate is the house's own (`--primary`) rather than a hex invented here (THE COLOUR LAW),
            and it is the plate rather than `--quiet`'s gold-on-plum because this is the conversion
            door and not a quiet control. */}
        {onUpgrade ? (
          <button type="button" className="button button--primary lala-turns__go" onClick={onUpgrade}>
            {t(language, view.action)}
          </button>
        ) : null}
      </div>
    );
  }
  if (!notice) return null;
  // `role="status"` rather than an alert: it is a gentle heads-up, so a screen reader should hear it
  // when it finishes what it is saying, not be interrupted by it.
  return (
    <p className={`lala-turns lala-turns--${notice.kind}`} role="status">
      {notice.text}
    </p>
  );
}
